import { detect } from 'detect-browser'
import { compare } from 'compare-versions'

enum BrowserVersionEnum {
  CHROME = '80',
  EDGE = '80',
  FIREFOX = '80',
  OPERA = '80',
  SAFARI = '13',
  CHROME_ANDROID = '63',
  FIREFOX_ANDROID = '63',
  SAFARI_ON_IOS = '12.2',
}

export const getBrowserVersionPromptStatus = () => {
  const browser = detect()
  if (!browser) return false
  const { version, name } = browser
  let showPrompt = false
  const checkStatus = (basicVersion: BrowserVersionEnum) => {
    showPrompt = compare(version!, basicVersion, '<')
  }
  if (name === 'chrome') {
    checkStatus(BrowserVersionEnum.CHROME)
  } else if (name === 'edge') {
    checkStatus(BrowserVersionEnum.EDGE)
  } else if (name === 'firefox') {
    checkStatus(BrowserVersionEnum.FIREFOX)
  } else if (name === 'opera') {
    checkStatus(BrowserVersionEnum.OPERA)
  } else if (name === 'safari') {
    checkStatus(BrowserVersionEnum.SAFARI)
  } else if (name === 'android') {
    checkStatus(BrowserVersionEnum.CHROME_ANDROID)
  } else if (name === 'ios') {
    checkStatus(BrowserVersionEnum.SAFARI_ON_IOS)
  }

  return showPrompt
}
